import { Caption, Video } from '@collab/atoms';

import { usePageContext } from 'libs/notion-renderer/PageProvider';
import createText from 'libs/notion-renderer/createText';
import { getAssetSrc } from 'libs/notion-renderer/utils';
import { NotionProps } from 'notion/types';

const NotionVideo: React.FC<NotionProps> = ({ block }) => {
  const { assets, pagePath } = usePageContext();
  const assetSrc = getAssetSrc(pagePath, block, assets);
  const { aspectRatio, alt } = block;
  const caption = createText(block.video?.caption);

  return (
    <>
      <Video
        controls="enabled"
        srcMp4={assetSrc}
        aspectRatio={aspectRatio}
        ariaLabel={alt}
        disableRemotePlayback
      />
      {!!caption.length && <Caption>{caption}</Caption>}
    </>
  );
};
export default NotionVideo;
